/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：200__part-1
 */

"use strict"

var r
import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"./11"
import * as /* [auto-meaningful-name] */Module_75 from /* 75 */"./75"
import * as /* [auto-meaningful-name] */Src_editor_widget_builtIn_types from /* 5 */"../../../../src/editor/widget/built-in/types"
var /* [auto-meaningful-name] */IconWidgetCheckbox = "icon-widget-checkbox"
var /* [auto-meaningful-name] */Ff2f2fff = "#ff2f2fff"
var /* [auto-meaningful-name] */_34c958ff = "#34c958ff"
var /* [auto-meaningful-name] */_148cefff = "#148cefff"
var d = false
var p = false
r = {}
Module_11.a(r, Src_editor_widget_builtIn_types.s.SMALL, {
  headlineFontSize: 14,
  optionFontSize: 12,
  innerSize: 16,
  minWidth: 60,
  maxWidth: Module_75.e
})
Module_11.a(r, Src_editor_widget_builtIn_types.s.MEDIUM, {
  headlineFontSize: 16,
  optionFontSize: 14,
  innerSize: 20,
  minWidth: 60,
  maxWidth: Module_75.e
})
Module_11.a(r, Src_editor_widget_builtIn_types.s.LARGE, {
  headlineFontSize: 18,
  optionFontSize: 16,
  innerSize: 24,
  minWidth: 60,
  maxWidth: Module_75.e
})
var f = r
export { IconWidgetCheckbox as s }
export { Ff2f2fff as c }
export { _34c958ff as l }
export { _148cefff as u }
export { d }
export { p }
export { f }
